<template>
<div class="container">
    <div class="row mb-1">
      <div class="col pb-1">
        <span class="badge rounded-pill pull-left mt-1 py-2 px-4 bg-primary" style="font-size:18px;">
                <b>Lab Receive : รับเข้าห้องแล็บ</b></span>
      </div>
    </div>
    <p class="text-start text-black-50 ms-2">ระบุหมายเลข "รอบนำส่ง" และป้อนเลขที่เอกสาร LAB NO. หรือสแกนบาร์โค้ด : ระบบจะทำการบันทึกเวลารับเข้าห้องแล็บเพื่อจัดทำ Work Sheet ต่อไป</p>
    <div class="row mb-2">
        <div class="col-sm-3">
            <!-- รอบนำส่ง Specimen 1, 2, ... 9 -->
            <div class="input-group input-group-sm">
                <span class="input-group-text">รอบนำส่งที่ *</span>
                <select class="form-select form-select-sm" ref="ReceivedRound" @change="getData()"
                  id="ReceivedRound" name="ReceivedRound" v-model="ReceivedRound" >
                    <option disabled value="">Please select one</option>
                    <option v-for="item in [1,2,3,4,5,6,7,8,9]" :key="item" :value="item">{{ item }}</option>
                </select>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="input-group input-group-sm mb-2">
                <span class="input-group-text" style="width:120px;">L.N.* :</span>
                <input type="text" class="form-control form-control-sm" v-model="DocFm" v-on:keyup.enter="saveLabReceievedData()"
                    ref="DocFm" name="" id="RONoFm" placeholder="ป้อน L.N. No เพื่อรับเข้าห้องแล็บ" title="ป้อน L.N. No เพื่อรับเข้าห้องแล็บ">
            </div>
        </div>
        <div class="col text-start">
            <button type="button" class="btn btn-warning btn-sm text-dark mx-2" @click="saveLabReceievedData()">บันทึกรับเข้าห้องแล็บ</button>
        </div>
    </div>
    <div id="divToPrint" class="container">
        <table id="myLabNoTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
            <thead>
            <tr class="bg-dark text-white">
                <th style="width:20px;">No.</th>
                <th style="width:100px;"><u>วันเวลารับเข้าแล็บ</u> </th>
                <th style="width:50px;">รอบนำส่ง</th>
                <th style="width:20px;">Status</th>
                <th style="width:80px; text-align:center;">เลขที่ใบตรวจ</th>
                <th style="width:130px;">ชื่อ-สกุล คนไข้</th>
                <th style="width:30px;">เพศ</th>
                <th style="width:40px;">อายุ(ปี)</th>
                <th style="width:80px;">เทสตรวจ</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in dataReceivedLists" :key="item.ROID" v-bind:data-id="item.ROID">
                <td class="" >{{ index + 1 }}.</td>
                <td class="text-start" >{{ item.ReceivedDate }}</td>
                <td class="" >{{ item.ReceivedRound }}</td>
                <td class="" >{{ arrDocStatus[item.Status] }}</td>
                <td class="text-start" >{{ item.RONo }}</td>
                <td class="text-start" >{{ item.PatName }} {{ item.PatLName}}</td>
                <td class="" style="text-align:center;">{{ arrSex[item.Sex] }}</td>
                <td class="" style="text-align:center;">{{ item.AgeYears }}</td>
                <td class="text-start" >{{ item.Test }}</td>
            </tr>
            </tbody>
        </table>
        <!-- <h4>รวม &nbsp; {{ dataReceivedLists.length }} &nbsp; รายการ</h4> -->
    </div>
</div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'LabCreate',
  data () {
    return {
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      // เงื่อนไข
      dataReceivedLists: [],
      DocFm: '',
      ReceivedRound: 1
    }
  },
  mounted () {
    this.getData()
  },
  components: {

  },
  methods: {
    saveLabReceievedData () {
      if (this.DocFm === '') {
        this.$refs.DocFm.focus()
        Swal.fire({ icon: 'info', text: 'กรุณาป้อนเลขที่เอกสาร (L.N.)', showConfirmButton: false, timer: 1000 })
        return
      }
      // ======================================= //
      var self = this
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/update_labreceived.php',
        data: { request: { CorpID: self.globalCorpID, RONo: this.DocFm, ReceivedRound: this.ReceivedRound } },
        statusCode: {
          200: function () {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
              showConfirmButton: false,
              timer: 1500
            })
          },
          204: function () {
            Swal.fire({ icon: 'error', text: 'ไม่พบเอกสารเลขที่ระบุ' })
          },
          404: function () {
            alert('page not found')
          }
        }
      })
        .done(function (resp) {
          self.getData()
          self.DocFm = ''
          self.$refs.DocFm.focus()
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    getData () {
      var self = this
      // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/labreceived_where.php?C1=' + this.globalCorpID + '&ReceivedRound=' + self.ReceivedRound)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataReceivedLists = resp.data.response
          // setTimeout(function () { this.$refs.myBranchTable.DataTable() }, 0)
          setTimeout(function () { $('#myLabNoTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
